// An agent's preview signs a browser in from its link (agent-factory README
// "Previews"): the factory's gateway sends the owner to
// /preview-enter?token=…&next=/the/page, where the token is the preview server's
// own. It is taken only when that server says it is a preview (ALFIEOS_PREVIEW=1,
// /api/config `preview`), so on any real server the path signs nobody in.

export const PREVIEW_ENTER = '/preview-enter'

/** The landing path, kept inside the app. */
export const previewNext = (next: string | null): string =>
  next && next.startsWith('/') && !next.startsWith('//') && !/[\\\r\n]/.test(next) ? next : '/'

export interface PreviewEntry {
  token: string
  next: string
}

/** The entry this location asks for, if it is the preview's way in. */
export const previewEntry = (pathname: string, search: string): PreviewEntry | null => {
  if (pathname !== PREVIEW_ENTER) return null
  const q = new URLSearchParams(search)
  return { token: (q.get('token') ?? '').trim(), next: previewNext(q.get('next')) }
}

/** Whether the server behind token is a preview (anything else, or no answer, is no). */
export const isPreviewServer = async (token: string, fetchFn: typeof fetch = fetch): Promise<boolean> => {
  if (token.length < 32) return false
  try {
    const r = await fetchFn('/api/config', { headers: { Authorization: `Bearer ${token}` } })
    if (!r.ok) return false
    const c = (await r.json()) as { preview?: boolean }
    return c.preview === true
  } catch {
    return false
  }
}
